// extracted by mini-css-extract-plugin
module.exports = {"heading1":"text__heading1","heading2":"text__heading2","formLabelBold":"text__formLabelBold","formFieldValue":"text__formFieldValue","warning":"text__warning"};